export const valueMustBePositive: string = 'wartość musi być dodatnia'
export const valueMustBeNegative: string = 'wartość musi być ujemna'
export const valueMustBeAnumber: string = 'wartość musi być cyfrą'
export const valueMustBeInteger: string = 'wartość musi być liczbą całkowitą'
export const valueCantBeEmpty: string = 'wartość nie może być pusta'
